export default ({ request }) => ({
  ecomAmzFtyOutboundListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyOutboundDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyOutboundSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyOutboundDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyOutboundAuditApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/audit',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyOutboundDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyOutboundAddByNoticeOutListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/outbound/addByNoticeOutList',
      method: 'POST',
      data,
    })
  },
})
